import React, {Component} from 'react';

import { bf } from './bf';
import { ic } from './ic';
import { iv } from './iv';
import { ip } from './ip';
import { cp } from './cp';
import { cf } from './cf';
import { ce } from './ce';
import cUserList from './cUserList';

class iUserList extends cUserList {

  constructor(props) { // state の宣言だけでは駄目な模様
    super(props);
    this.state = cf.myRN_crt_stss(
      this.$cd_stss,
      this.$id_stss
    );
  }

  render() {
bf.l('23: {}, {}'.f(global.c?.state.sgc_pageRole, global.c?.state.sgcd_pagePntKeys.cm10c410))
    return (
      <ce.RootDtl
        key={-1}
        b_logo={false}
        b_sch={false}
        onSchEnt={null}
        rhtIconName='plus'
        rhtPfx='新規'
        onRhtPrs={()=>{
          let _d_pageInfs = {
/*
            sgc_pageRole: bf.b([
              {
                b_when: global.c?.state.sgcd_pagePntKeys.cm10c410 == '20',
                o_then: () => 'adm2',
              },
              {
                b_when: global.c?.state.sgcd_pagePntKeys.cm10c410 == '90',
                o_then: () => 'own3',
              },
              {
                o_else: () => 'mmb1',
              },
            ]),
*/
            sgc_pageRole:
              (global.c?.state.sgc_pageRole == 'own2') ?
                'own3'
              : (global.c?.state.sgc_pageRole == 'adm1') ?
                'adm2'
              : 'mmb1'
            ,
            sgc_pageName: 'iUserDtl',
            sgc_pageKey: '',
            sgc_pageMode: 'new',
            sgc_pagePrc: '',
          };
          cf.myRN_move_fwd(_d_pageInfs);
        }}
        n_bdyW={ic.gn_w}
        d_hdrs={{
          pfx: iv._get_hdrPfx('利用者一覧'),
          d_leftBtns: iv._get_leftBtns(global.c?.state.sgc_pageRole, cf.myNV_get_name(), global.c?.state.sgc_pageMode),
          d_subMenus: {
            b_vsb:(bf.i(global.c?.state.sgc_cm10c410, ['20', '90'])) ? true : false,
            ld_iss: [
              ip.$dd_subMenuss['利用者CSV出力'],
              ip.$dd_subMenuss['利用者CSV取込'],
            ],
          },
        }}
        d_bdys={{
          ld_defss: [
            {
              type: 'List',
              pfx: '',
              state: 'sld_cm10ss',
/*
              nextRole: bf.b([
                {
                  b_when: global.c?.state.sgcd_pagePntKeys.cm10c410 == '20',
                  o_then: () => 'adm2',
                },
                {
                  b_when: global.c?.state.sgcd_pagePntKeys.cm10c410 == '90',
                  o_then: () => 'own3',
                },
                {
                  o_else: () => 'mmb1',
                },
              ]),
*/
              nextRole: 
                (global.c?.state.sgc_pageRole == 'own2') ?
                  'own3'
                : (global.c?.state.sgc_pageRole == 'adm1') ?
                  'adm2'
                : 'mmb1'
              ,
//              nextPage: 'iHome',
              nextPage: 'iUserDtl',
              pagePntKeyName: 'cm10_key', // sgcd_pagePntKeys へ反映するために必要
              b_edt: false,
              b_img: false,
              b_bdr: false,
            },
          ],
        }}
      />
    );
  }
};

export default iUserList;
